<template>
  <v-ons-page>

    <v-ons-toolbar class="toolbar--noshadow" modifier="perfhome">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        Mon alerte - {{ cultLabel }}
      </div>
      <div class="right">
        <v-ons-toolbar-button @click="deleteAlerteConfirm">
          <v-ons-icon icon="trash"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="content content--perfonglet">

      <v-ons-list modifier="noborder perflist">

        <v-ons-list-item modifier="chevron perfchevron" @click="setAlerte" tappable>
          <div class="center">
            Seuil d'alerte {{ alerteInfos.suffix }}
          </div>
          <div class="right">
            <div class="list-item__label">
              {{ coursObjectif }} €/t
            </div>
          </div>
        </v-ons-list-item>

        <template v-if="strategie.negoce">
          <v-ons-list-item modifier="perfbutton" key="list-item-negoce-select">
            <v-ons-button modifier="quiet" @click="showAlertePrix">
              Choisir les prix à suivre
            </v-ons-button>
          </v-ons-list-item>
        </template>
        <template v-else-if="alerteInfos.isEuronext">

          <v-ons-list-item v-if="! strategie.echeance" modifier="perfbutton" key="list-item-echeance-select">
            <v-ons-button modifier="quiet" @click="showAlerteEcheance">
              Choisir une échéance à suivre
            </v-ons-button>
          </v-ons-list-item>

          <v-ons-list-item v-else modifier="chevron perfchevron" key="list-item-echeance-chevron"
                          @click="showAlerteEcheance" tappable>
            <div class="center">
              Échéance suivie
            </div>
            <div class="right">
              <div class="list-item__label">
                {{ getLabelEcheance(strategie.echeance) }}
              </div>
            </div>
          </v-ons-list-item>

        </template>

      </v-ons-list>

      <v-ons-list modifier="noborder perflist">
        <v-ons-list-item modifier="perfswitch">
          <label class="center">
            Alerte &#x1F44D;
            <span>si le {{ strategie.negoce ? 'prix' : 'cours' }} passe au-dessus</span>
          </label>
          <div class="right">
            <v-ons-switch :modifier="$mdModifier" v-model="params.is_higher"></v-ons-switch>
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="perfswitch">
          <label class="center">
            Alerte &#x1F44E;
            <span>si le {{ strategie.negoce ? 'prix' : 'cours' }} passe en dessous</span>
          </label>
          <div class="right">
            <v-ons-switch :modifier="$mdModifier" v-model="params.is_lower"></v-ons-switch>
          </div>
        </v-ons-list-item>
      </v-ons-list>

    </div>

    <v-ons-bottom-toolbar modifier="cta transparent">
      <v-ons-button modifier="large--cta perflarge" @click="setAlerte">
        Modifier mon alerte
      </v-ons-button>
    </v-ons-bottom-toolbar>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from "../store.js";
 
import AppAlerteSeuil from './AlerteSeuil.vue';
import AppAlertePrix from './AlertePrix.vue';
import AppAlerteEcheance from './AlerteEcheance.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  props: ['pageStack'],
  data() {
    return {
      refCulture: '',
      refDestination: '',
      params: {
        is_higher: true,
        is_lower: true
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    coursObjectif() {
      if (this.strategie.negoce){
        return this.strategie.objectif;
      } else {
        return this.getCoursFromEffectif(
          this.strategie.objectif,
          this.referentiel.cultures[this.refCulture].destinations[this.refDestination],
          this.strategie.diff);
      }
    },
    alerteInfos() {
      var alerteInfos = {
        suffix: '',
        isEuronext: false
      };
      if(!this.strategie.negoce && this.strategie.contrat === undefined){
        var coursName = this.referentiel.cultures[this.refCulture].destinations[this.refDestination].cours;
        alerteInfos.suffix = this.getCoursSuffix(coursName);
        if(this.referentiel.cours[coursName].echeances){
          alerteInfos.isEuronext = true;
        }
      }
      return alerteInfos;
    }
  },
  watch: {
    'params.is_higher'(value) {
      if (value != this.strategie.params.is_higher) {
        this.updateParams();
      }
    },
    'params.is_lower'(value) {
      if (value != this.strategie.params.is_lower) {
        this.updateParams();
      }
    }
  },
  methods: {
    setAlerte() {
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppAlerteSeuil,
        data() {
          return {
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    },
    showAlertePrix() {
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppAlertePrix,
        data() {
          return {
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    },
    showAlerteEcheance() {
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppAlerteEcheance,
        data() {
          return {
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    },
    updateParams() {
      this.mergeJson(store.state.user.ventes[this.refCulture][this.refDestination].params, this.params);
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath('/alerte'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination,
            data: {
              params: this.params
            }
          }
        }
      });
    },
    deleteAlerteConfirm() {
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Attention !',
        message: "Êtes-vous sûr de vouloir supprimer cette alerte ?",
        buttonLabels: ['Annuler', 'Supprimer'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteAlerte();
          }
        }.bind(this)
      });
    },
    deleteAlerte() {
      store.state.user.ventes[this.refCulture][this.refDestination].objectif = '';
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          method: 'DELETE',
          path: this.getPath('/alerte'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination
          }
        }
      });

      this.pageStack.pop();
    }
  },
  created() {
    if(this.strategie.params){
      this.setJson(this.params, this.strategie.params);
    }
  }
};
</script>